<style scoped>
.header {
  min-width: 1300px;
  /* min-width: 1200px; */
  width: 100%;
  height: 90px;
  background: #fff;
}

.header-cont {
  width: auto;
  margin: 0 0 0 30px;
}

.header-cont > .logo {
  float: left;
  width: 55px;
  margin: 25px 10px 0;
}
.header-cont > .logo-title{
  float: left;
  font-size: 20px;
  line-height: 90px;
}
.header-cont > .logoTitle {
  float: left;
  padding-left: 15px;
  font-size: 15px;
  color: #444;
  line-height: 90px;
}
.header-cont > .logo img {
  width: 100%;
}
.header-cont .right-nav {
  width: 560px;
  margin: 0 auto;
  overflow: hidden;
}

.header-cont .right-nav li {
  height: 90px;
  width: 140px;
  float: left;
  margin: auto 0;
  line-height: 85px;
  padding: 0 !important;
}
.header-cont .right-nav li:hover {
  background: none;
}

.header-cont .right-nav li > a {
  display: block;
  width: 100%;
  height: 100%;
  font-size: 15px;
  color: #666;
  text-align: center;
  transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
}

.header-cont .right-nav li > a:hover {
  font-weight: bold;
  color: #6187fb;
  font-weight: bold;
  font-size: 17px;
}
.header-cont .right-nav li > a::after {
  content: "";
  height: 0;
  transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
}
.header-cont .right-nav li > a:hover::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 90px;
  left: 25px;
  height: 5px;
  background: linear-gradient(
    -90deg,
    rgba(120, 117, 249, 1) 0%,
    rgba(34, 181, 255, 1) 100%
  );
  border-radius: 2px;
}
.router-link-active {
  font-weight: bold;
  color: #6187fb !important;
  font-weight: bold;
  font-size: 17px !important;
  position: relative;
}
.router-link-active::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 90px;
  left: 25px;
  height: 5px !important;
  background: linear-gradient(
    -90deg,
    rgba(120, 117, 249, 1) 0%,
    rgba(34, 181, 255, 1) 100%
  );
  border-radius: 2px;
}

.header-info {
  float: left;
  cursor: pointer;
  position: relative;
  height: 90px;
  line-height: 90px;
  padding-right: 25px;
  box-sizing: border-box;
}
.header-info::after,.setStyle.set::after {
  content: "";
  width: 1px;
  height: 20px;
  background: #d5d9e3;
  position: absolute;
  top: 35px;
  right: 0;
}
.header-info > .current {
  color: #666;
  font-size: 13px;
  float: left;
}
.header-info > .header-img {
  width: 46px;
  height: 90px;
  overflow: hidden;
  float: left;
}

.header-info > .header-img > img {
  width: 100%;
}

.bossname {
  float: left;
  margin: auto 10px;
  color: #444;
  font-size: 18px;
  font-weight: bold;
}

.header-info > i {
  margin: 4px 0;
  float: left;
}
.setStyle {
  width: 88px;
  height: 90px;
  padding-top: 25px;
  text-align: center;
  float: right;
  color: #666;
  font-size: 11px;
  position: relative;
  cursor: pointer;
}
</style>
<template>
  <el-menu class="myHeaderTab" :default-active="$route.path" :collapse="isHeaderCollapse">
    <div class="header">
      <div class="header-cont">
        <span class="logo">
          <img
            src="../../assets/images/store/denglu_logo.png"
            @click="gohome"
          >
        </span>
        <b class="logo-title">智能门店管理系统</b>
        <span class="logoTitle">欢迎进入商户中心</span>
        <div style="float: right;height: 90px;">
          <div class="header-info">
            <span class="header-img">
              <img src="../../assets/images/store/logo_tingmei.png">
            </span>
            <span class="bossname">{{$store.state.userInfo.staffName}}</span>
            <span class="current">您好！</span>
          </div>
          <div class="setStyle" @click="logout" v-loading.fullscreen.lock="fullscreenLoading">
            <i>
              <img src="../../assets/images/boss/btn_exit.png" alt>
            </i>
            <p>退出</p>
          </div>
          <div class="setStyle set">
            <i>
              <img src="../../assets/images/boss/btn_set.png" alt>
            </i>
            <p>设置</p>
          </div>
        </div>
        <div class="right-nav">
          <el-menu-item index="1" v-if="$store.state.roleFlags == 1">
            <router-link to="/bossCenter">营收监控</router-link>
          </el-menu-item>
          <el-menu-item index="2">
            <router-link to="/allStore">所有门店</router-link>
          </el-menu-item>
          <!-- <el-menu-item index="3">
            <router-link to="/training">培训报名</router-link>
          </el-menu-item> -->
          <!-- <el-menu-item index="4">
            <router-link to="/accountCenter">账户中心</router-link>
          </el-menu-item> -->
        </div>
      </div>
    </div>
  </el-menu>
</template>
<script>
import {toLoginOut} from '@/api'
export default {
  data() {
    return {
      fullscreenLoading: false,
      tabFlag: false,
      isHeaderCollapse: false
    };
  },
  methods: {
    //注销
    logout() {
      //删除cookie并跳到登录页

      this.fullscreenLoading = true;
      this.delCookie("session");
      //演示
      toLoginOut().then(res=>{
        setTimeout(() => {
          this.fullscreenLoading = false;
          this.$router.push("/login/");
        }, 500);
      })
    },
    gohome() {
      setTimeout(() => {
        this.fullscreenLoading = false;
        this.$router.push("/home");
      }, 500);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/bossHeader.vue